import { useTranslation } from 'react-i18next';
import { cn } from 'lib/utils';
import type { VoiceCaption } from '../types/voice-call.types';

interface VoiceCaptionsProps {
  agentCaption: VoiceCaption | null;
  userCaption: VoiceCaption | null;
  className?: string;
}

/** Last thing each side said; interim (not yet final) text is dimmed. */
export const VoiceCaptions = ({ agentCaption, userCaption, className }: VoiceCaptionsProps) => {
  const { t } = useTranslation();
  if (!agentCaption && !userCaption) return null;

  return (
    <div
      aria-live="polite"
      className={cn('flex w-full max-w-2xl flex-col gap-3 px-6 text-center', className)}
    >
      {userCaption && (
        <p
          data-testid="voice-caption-user"
          className={cn(
            'text-sm text-muted-foreground line-clamp-2',
            !userCaption.isFinal && 'opacity-70'
          )}
        >
          <span className="font-medium">{t('VOICE_CALL_YOU', { defaultValue: 'You' })}: </span>
          {userCaption.text}
        </p>
      )}
      {agentCaption && (
        <p
          data-testid="voice-caption-agent"
          className={cn(
            'text-base text-foreground line-clamp-4 sm:text-lg',
            !agentCaption.isFinal && 'opacity-70'
          )}
        >
          {agentCaption.text}
        </p>
      )}
    </div>
  );
};
